import styled from 'styled-components';

export const Container = styled.div`
  cursor: pointer;
  background: #f5f5f5;

  .upload-list-inline {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .ant-upload-list-picture-container {
    float: right;
    width: 150px;
    display: block;
    margin-right: 5px;
  }

  .ant-upload-list-item {
    margin-top: 0;
    margin-bottom: 5px;
  }
`;

export const CaixaUpload = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background: #f5f5f5;
  /* border: 1px dashed #d9d9d9; */
  border-radius: 2px;
  min-height: 140px;
`;

export const ContainerImg = styled.div`
  align-self: center;
  margin-bottom: 10px;
`;

export const TextAttachment = styled.p`
  font-size: 12px;
`;

export const TextInfo = styled(TextAttachment)`
  font-weight: 700;
`;
